define('VATTaxes.ExtraLabel.View', [
	'vattaxes_extra_label.tpl',
	'Backbone'
], function (
	vattaxes_extra_label_tpl,
	Backbone
) {
	'use strict';

	// @class Tavano.TTVatTaxes.VATTaxes.View @extends Backbone.View
	return Backbone.View.extend({

		template: vattaxes_extra_label_tpl,

		initialize: function (options) {
      this.isPLP = options.isPLP;
      this.isCart = options.isCart;
			this.listenTo(Backbone, 'vatTaxes:change', this.updateLabel);
		},

		updateLabel: function updateLabel(toggle) {
			this.render();
		},

		getContext: function getContext() {
			return {
				excVat: !$('[data-action="toggleIcon"]').hasClass('active'),
        isPLP: this.isPLP,
        isCart: this.isCart
			};
		}
	});
});
